import { ProgressKey, Section } from "@appally/collections/Assessment";

export const stringToSection = (str: string): Section | undefined => {
  switch (str?.toLowerCase().trim()) {
    case "about_you":
      return Section.about_you;
    case "about_your_job":
      return Section.about_your_job;
    case "workplace_challenge":
      return Section.workplace_challenge;
    default:
      return undefined;
  }
};

export const sectionToProgressKey = (section: Section): ProgressKey => {
  switch (section) {
    case Section.about_you:
      return "about_you";
    case Section.about_your_job:
      return "about_your_job";
    case Section.workplace_challenge:
      return "workplace_challenges";
  }
};

export const progressKeyToSection = (key: ProgressKey): Section | undefined => {
  switch (key) {
    case "about_you":
      return Section.about_you;
    case "about_your_job":
      return Section.about_your_job;
    case "workplace_challenges":
      return Section.workplace_challenge;
  }
};

export const getAssessmentProgressKeys = (
  omitKey?: ProgressKey
): ProgressKey[] => {
  const keys: ProgressKey[] = [
    "about_you",
    "about_your_job",
    "workplace_challenges",
  ];
  if (!omitKey) return keys;
  return keys.filter((key) => key !== omitKey);
};
